
import { TreatmentServicesSection } from "@/components/services/TreatmentServicesSection";
import { laserDentistryData } from "./laserDentistryData";

export const LaserDentistryServices = () => {
  return (
    <TreatmentServicesSection
      title="Our Laser Dentistry Services"
      subtitle="Services We Offer"
      description="At Asrani Dental in Sadar, Nagpur, we provide a wide range of laser dental treatments for enhanced patient comfort and superior results."
      services={laserDentistryData.services}
    />
  );
};
